import {ReactElement} from "react";
import {ImageDropzone} from "./ImageDropzone";
import {FormattedMessage} from "react-intl";
import {getImageSize} from "../../../lib/util";

export interface LocalImage {
    dataUrl: string
    binaryData: File
    stats: LocalImageStats
}

export interface LocalImageStats {
    width: number
    height: number
    fileSize: number
}

export interface LocalImagePickerProps {
    image: LocalImage|null
    onPickImage: (image: LocalImage) => void
}

export function LocalImagePicker(props: LocalImagePickerProps): ReactElement {
    const image = props.image;
    const onSetBinaryImage = (binaryImage: File) => {
        const url = URL.createObjectURL(binaryImage);
        getImageSize(url)
            .then(imageSize => {
                const image = {
                    dataUrl: url,
                    binaryData: binaryImage,
                    stats: {
                        fileSize: binaryImage.size,
                        width: imageSize.width,
                        height: imageSize.height
                    }
                };
                props.onPickImage(image);
            })
        return () => URL.revokeObjectURL(url);
    }

    return (
        <div className="w-full h-full relative">
            <ImageDropzone onSetImage={onSetBinaryImage}>
                <div className="absolute inset-0 overflow-hidden">
                    {(image?.dataUrl) != null ? (
                        <div className="w-full h-full">
                            <img alt="Preview"
                                 className="w-full h-auto max-h-full object-contain"
                                 src={image.dataUrl}
                            />
                        </div>
                    ) : (
                        <div className="w-full h-full flex items-center justify-center border border-2 border-dashed border-gray-2 rounded-lg">
                            <FormattedMessage id="editor.image.upload.dropzone.dragndropOrClick"/>
                        </div>
                    )}
                </div>
            </ImageDropzone>
        </div>
    );
}